
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Contact",
      function () {
        return require("private-next-pages/Contact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Contact"])
      });
    }
  